import { Controller, useFormContext } from 'react-hook-form';
import { FC } from 'react';

import { CollapseCheckbox } from '../components/collapseCheckbox';
import { TermostatstyringRadio } from '../components/termostatstyringRadio';
import { AboutFormControlProps, AboutFormData } from '../../types';
import { Termostatstyring } from '../../../../../utils/registerEnums';

export const Panelovn: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext<AboutFormData>();

  return (
    <Controller
      control={control}
      name="oppvarming.oppvarmingElektrisk.panelovn.selected"
      render={({ field: { value, onChange }, fieldState }) => (
        <CollapseCheckbox
          checked={!!value}
          onChange={(checked) => {
            onChange(checked);

            const newValue = checked ? { termostatstyring: Termostatstyring.Ukjent } : undefined;

            setValue('oppvarming.oppvarmingElektrisk.panelovn.value', newValue);
          }}
          error={!!fieldState.error}
          labelKey={'register.tekniskUtstyr.panelovn.label'}
        >
          <Controller
            control={control}
            name="oppvarming.oppvarmingElektrisk.panelovn.value.termostatstyring"
            render={({ field: { value, onChange }, fieldState }) => (
              <TermostatstyringRadio
                value={value}
                onChange={onChange}
                error={fieldState.error}
                labelKey="register.termostatstyring.panelovn.label"
                informationKey="register.termostatstyring.panelovn.information"
              />
            )}
          />
        </CollapseCheckbox>
      )}
    />
  );
};
